import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { getAuditType } from "@/lib/auditTypes";

const BUILT_IN_KEYS = ["gdpr", "nis2", "iso27001", "dora", "ai_act"];
const categoryLabel = (category) => BUILT_IN_KEYS.includes(category) ? getAuditType(category).label : category === "custom" ? "Altre checklist" : category;

export default function Templates() {
  const [templates, setTemplates] = useState([]);
  const load = () => api.get("/templates").then((r) => setTemplates(r.data)).catch(() => toast.error("Errore caricamento"));
  useEffect(() => { load(); }, []);

  const categories = BUILT_IN_KEYS.map((key) => ({ key, items: templates.filter((t) => (t.category || t.type) === key) }))
    .concat(Array.from(new Set(templates.map((t) => t.category || "custom")))
      .filter((key) => !BUILT_IN_KEYS.includes(key))
      .map((key) => ({ key, items: templates.filter((t) => (t.category || "custom") === key) })));

  return (
    <div className="p-6 md:p-10 max-w-6xl">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-2">Checklist</div>
        <h1 className="font-display font-black text-4xl md:text-5xl">Template audit</h1>
        <p className="text-slate-500 mt-2 text-sm max-w-xl">Scegli una normativa per visualizzare le checklist organizzate per TAG.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {categories.map(({ key, items }) => (
          <Link key={key} to={`/app/template/categoria/${encodeURIComponent(key)}`} data-testid={`template-category-${key}`} className="group bg-white border border-slate-200 rounded-lg p-6 hover:border-slate-400 hover:shadow-sm transition-all duration-200">
            <div className="flex items-start justify-between gap-4">
              <div>
                <div className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-2">Categoria</div>
                <h2 className="font-display font-bold text-2xl text-slate-900 group-hover:text-blue-700 transition-colors">{categoryLabel(key)}</h2>
                <p className="text-sm text-slate-500 mt-2">Apri le checklist di questa categoria.</p>
              </div>
              <div className="text-right shrink-0">
                <div className="font-display font-black text-3xl text-slate-900">{items.length}</div>
                <div className="text-xs text-slate-400">checklist</div>
              </div>
            </div>
            <div className="mt-5 text-xs text-blue-600 font-medium">Accedi alla categoria →</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
